var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepairSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1801 15.998H4.74567C3.8848 15.998 3.05919 15.656 2.45046 15.0472C1.84173 14.4385 1.49976 13.6129 1.49976 12.752V5.44875C1.49976 4.58788 1.84173 3.76227 2.45046 3.15354C3.05919 2.54481 3.8848 2.20284 4.74567 2.20284H13.6719C14.5328 2.20284 15.3584 2.54481 15.9671 3.15354C16.5759 3.76227 16.9178 4.58788 16.9178 5.44875V7.88318M6.36862 1.39136V3.01431M12.049 1.39136V3.01431M1.49976 6.26022H16.9178",
    stroke: "#04245C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6072 9.27308C10.8985 8.56444 9.80545 8.38943 8.89311 8.85421L10.2731 10.2342L9.12549 11.3818L7.7455 10.0018C7.28072 10.9142 7.45573 12.0072 8.16438 12.7159C8.87302 13.4245 9.96611 13.5995 10.8785 13.1348L14.9811 17.2374C15.1303 17.3866 15.2814 17.3847 15.3962 17.27L16.1613 16.5049C16.276 16.3901 16.2779 16.239 16.166 16.1271L12.0634 12.0245C12.5281 11.1121 12.3531 10.019 11.6072 9.27308Z",
    fill: "#2173FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepairSchedule);
export default __webpack_public_path__ + "static/media/repair_schedule.fe6e12f5e1d8b02e4bb2fb5a43fb61d5.svg";
export { ForwardRef as ReactComponent };